import React, { useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';


const stats = [
    {
        id: 1,
        value: "8+",
        label: "Years In Business",
        borderColor: "blue",
    },
    {
        id: 2,
        value: "15+",
        label: "Industries Serve",
        borderColor: "orange",
    },
    {
        id: 3,
        value: "50+",
        label: "Projects Delivered",
        borderColor: "blue",
    },
    {
        id: 4,
        value: "95%",
        label: "Client Retention",
        borderColor: "blue",
    },
];

const WhyChoose = () => {

    return (
        <section className="w-full lg:pb-20 pb-10 bg-white font-sans overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-6 md:px-[80px]">
                <div className="flex flex-col lg:flex-row items-center relative z-0">

                    {/* LEFT: IMAGE SECTION */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="w-full lg:w-full max-w-[716px] h-[400px] lg:h-[496px] relative overflow-hidden z-0"
                    >
                        <img
                            src="/assets/hire-n/img2.png"
                            alt="Technology Background"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-[#0E2A62]/20 mix-blend-multiply"></div>
                    </motion.div>

                    {/* RIGHT: STATS GRID */}
                    <div className="w-full lg:w-full max-w-[820px] lg:-ml-[250px] relative z-10 bg-transparent flex flex-col justify-center">

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
                            {stats.map((stat, index) => (
                                <motion.div
                                    key={stat.id}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    className="flex flex-col gap-[20px] lg:py-[40px] py-[20px] lg:px-[40px] px-[20px] bg-[#FFFFFF] relative pb-8 group cursor-pointer hover:shadow-xl transition-shadow duration-300"
                                >
                                    <h3 className="text-[#01386A] text-[32px] md:text-[40px] font-[600] leading-none font-sora">
                                        {stat.value}
                                    </h3>
                                    <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] font-graphik">
                                        {stat.label}
                                    </p>
                                    <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#0E2A62]"></div>
                                    <div className="absolute bottom-0 left-0 h-[3px] bg-[#F06115] w-0 group-hover:w-full transition-all duration-700 ease-in-out z-10"></div>

                                </motion.div>
                            ))}
                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhyChoose;